
import { computed, defineComponent, reactive } from 'vue'

import NewButton from '@/ui-kit/NewButton/index.vue'
import NewInput from '@/ui-kit/NewInput/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'

const BLACKLIST_TYPES = [
    { id: 1, name: 'Номер телефона' },
    { id: 2, name: 'Email' }
]

export default defineComponent({
    components: {
        NewButton,
        NewInput,
        NewSelect
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const state = reactive({
            identifier: null as string | null,
            typeId: null as number | null,
        })

        const extractNumbers = (str: string) => {
            return str.replace(/\D/g, '')
        }

        const onFiltersSubmit = () => {
            if (props.disabled || props.loading) return

            let identifier = state.identifier

            if (state.typeId && state.typeId === 1) {
                if (Boolean(identifier)) {
                    identifier = extractNumbers(identifier as string)
                }
            }

            emit('submit', {
                identifier,
                typeId: state.typeId,
            })
        }

        const onFiltersReset = () => {
            state.identifier = null
            state.typeId = null

            emit('reset')
        }

        const identifierPlaceholder = computed(() => {
            if (state.typeId) {
                if (state.typeId === 1) return 'Введите номер телефона'
                if (state.typeId === 2) return 'Введите email'
            }

            return 'Введите идентификатор'
        })

        return {
            state,
            BLACKLIST_TYPES,
            onFiltersSubmit,
            onFiltersReset,
            identifierPlaceholder,
        }
    }
})
